/* INFINTOS — sanftes Erscheinen, Filterschichten, Fragen */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function boot() {
    /* Erst jetzt verstecken — läuft das Skript nicht, bleibt alles sichtbar. */
    if (!reduce && 'IntersectionObserver' in window) {
      document.documentElement.classList.add('inf-anim');
    }
    if (reduce || !('IntersectionObserver' in window)) {
      document.querySelectorAll('.inf-rev,.inf-layer').forEach(function (el) { el.classList.add('inf-in'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('inf-in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
      document.querySelectorAll('.inf-rev:not(.inf-in)').forEach(function (el) { io.observe(el); });

      var lio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var i = [].indexOf.call(e.target.parentNode.children, e.target);
            e.target.style.transitionDelay = (i * 140) + 'ms';
            e.target.classList.add('inf-in');
            lio.unobserve(e.target);
          }
        });
      }, { threshold: 0.3 });
      document.querySelectorAll('.inf-layer:not(.inf-in)').forEach(function (el) { lio.observe(el); });
    }

    document.querySelectorAll('.inf-faq').forEach(function (group) {
      var ds = group.querySelectorAll('details');
      ds.forEach(function (d) {
        if (d.dataset.infBound) return;
        d.dataset.infBound = '1';
        d.addEventListener('toggle', function () {
          if (d.open) ds.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', boot);
  /* Im Theme-Editor nach jeder Änderung neu starten */
  document.addEventListener('shopify:section:load', boot);
})();
